import { useQuery } from "react-query";
import { getAllVirtualClassesRTQ, getClassById } from "../api/virtualClass";

const staleTime = 180000;
const cacheTime = 600000;

export function getVirtualClasses() {
  return useQuery(["getAllVirtualClassesRTQ"], getAllVirtualClassesRTQ, {
    enabled: true,
    staleTime: staleTime,
    cacheTime: cacheTime,
  });
}

/** get class details */
export const getClassDetailsById = (classId) => {
  return useQuery(["getClassById", classId], () => getClassById(classId), {
    enabled: true,
    staleTime: staleTime,
    cacheTime: cacheTime,
  });
};
